import {
  PERMISSION_LIST_REQUEST,
  PERMISSION_LIST_SUCCESS,
  PERMISSION_LIST_FAIL
} from '../../constants/permissions'

const initialState = {
  permissions: [],
  loading: false,
  pageable: {},
  status: '',
  error: ''
}

const permissionReducer = (state = initialState, action) => {
  switch (action.type) {
    // ** Section List Permission
    case PERMISSION_LIST_REQUEST:
      return { ...state, loading: true }
    case PERMISSION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        permissions: action.payload,
        pageable: action.pageable
      }
    case PERMISSION_LIST_FAIL:
      return { ...state, loading: false, error: action.payload, permissions: [] }

    default:
      return state
  }
}

export default permissionReducer
